import styled from "styled-components";
import { domAux, domAuxTerInf } from "../utils/globalConst";

export const ClipPathStyled = styled.clipPath`
  transition: ${({ hasTransition }) =>
    hasTransition ? `all 1s ease` : `none`};
  transform-origin: center;
`;

export const ArcLabel = styled.text`
  font-size: 24px;
  text-anchor: middle;
  font-family: "Work Sans", sans-serif;
`;

export const ArcLabelExvert = styled(ArcLabel)`
  ${({ currStackFunc, isExvert }) => `
    font-size: ${
      isExvert && currStackFunc === "dominant"
        ? "36px"
        : isExvert && currStackFunc === "auxiliary"
        ? "24px"
        : "18px"
    };
    font-weight: ${isExvert && currStackFunc === "dominant" ? "700" : "500"};
  `}
`;

export const ArcLabelInvert = styled(ArcLabel)`
  ${({ currStackFunc, isExvert }) => `
    font-size: ${
      !isExvert && currStackFunc === "dominant"
        ? "36px"
        : !isExvert && currStackFunc === "auxiliary"
        ? "24px"
        : "18px"
    };
    font-weight: ${!isExvert && currStackFunc === "dominant" ? "700" : "500"};
  `}
`;

export const StackLabel = styled.text`
  font-size: 14px;
  text-anchor: middle;
`;

export const StackLabelExvert = styled(StackLabel)`
  ${({ currStackFunc, isExvert }) => `
    text-transform: ${
      isExvert && domAux.some((c) => c === currStackFunc) ? "uppercase" : "none"
    };
    font-weight: ${isExvert && currStackFunc === "dominant" ? "700" : "500"};
  `}
`;

export const StackLabelInvert = styled(StackLabel)`
  ${({ currStackFunc, isExvert }) => `
    text-transform: ${
      !isExvert && domAux.some((c) => c === currStackFunc)
        ? "uppercase"
        : "none"
    };
    font-weight: ${!isExvert && currStackFunc === "dominant" ? "700" : "500"};
`}
`;
